import React, { useState, useEffect, useRef } from "react";
import { Play, X, ChefHat, ArrowRight } from "lucide-react";

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [loadedImages, setLoadedImages] = useState(new Set());
  const [visibleItems, setVisibleItems] = useState(new Set());
  const [hoveredItem, setHoveredItem] = useState(null);
  const observerRef = useRef();
  const galleryRef = useRef();

  const galleryItems = [
    { 
      id: 1, 
      type: "image", 
      src: "/images/006a936b-7913-43f6-bd9c-7b076a796eb4.jpg",
      title: "Signature Pasta Creation",
      description: "Fresh handmade pasta with our secret herb sauce",
      chef: "Chef Marco",
      difficulty: "Advanced",
      category: "pasta",
      rating: 4.9,
      preparationTime: "45 min",
      featured: true
    },
    { 
      id: 2, 
      type: "image", 
      src: "/images/04cb29bf-607a-4a95-80c3-ce90d2647c14.jpg",
      title: "Gourmet Burger Perfection",
      description: "Premium beef patty with artisanal toppings",
      chef: "Chef Sarah",
      difficulty: "Intermediate",
      category: "mains",
      rating: 4.8,
      preparationTime: "30 min",
      featured: true
    },
    { 
      id: 3, 
      type: "image", 
      src: "/images/10e434a6-cf8a-4ed6-b8bd-5d00536d2826.jpg",
      title: "Golden Crispy Delight",
      description: "Perfectly seasoned and golden-brown specialty",
      chef: "Chef Antonio",
      difficulty: "Beginner",
      category: "appetizers",
      rating: 4.7,
      preparationTime: "20 min"
    },
    { 
      id: 4, 
      type: "image", 
      src: "/images/20a334ad-86a1-4fff-8609-7b42200ac368.jpg",
      title: "Fresh Garden Salad",
      description: "Organic greens with house vinaigrette",
      chef: "Chef Emma",
      difficulty: "Beginner",
      category: "salads",
      rating: 4.6,
      preparationTime: "15 min"
    },
    { 
      id: 5, 
      type: "image", 
      src: "/images/22c8d1b2-99b5-414c-9edb-d22e96974458.jpg",
      title: "Artisan Bread Selection",
      description: "Freshly baked with premium ingredients",
      chef: "Chef Pierre",
      difficulty: "Advanced",
      category: "bakery",
      rating: 4.9,
      preparationTime: "180 min"
    },
    { 
      id: 6, 
      type: "image", 
      src: "/images/2cb5f0a3-e10c-40da-8a15-5ec4f78f47df.jpg",
      title: "Seafood Spectacular",
      description: "Ocean-fresh catch of the day",
      chef: "Chef Isabella",
      difficulty: "Advanced",
      category: "seafood",
      rating: 4.9,
      preparationTime: "40 min",
      featured: true
    },
    { 
      id: 7, 
      type: "image", 
      src: "/images/46482461-5e32-4843-8766-142f5f21c8f5.jpg",
      title: "Comfort Food Classic",
      description: "Traditional recipe with modern twist",
      chef: "Chef Michael",
      difficulty: "Intermediate",
      category: "mains",
      rating: 4.7,
      preparationTime: "35 min"
    },
    { 
      id: 8, 
      type: "image", 
      src: "/images/500ef44c-e233-45e3-8195-6fdf0e60cf1e.jpg",
      title: "Exotic Fusion Dish",
      description: "East meets West culinary adventure",
      chef: "Chef Yuki",
      difficulty: "Advanced",
      category: "fusion",
      rating: 4.8,
      preparationTime: "50 min"
    },
    { 
      id: 9, 
      type: "image", 
      src: "/images/5cb7ab07-ff16-4e75-a4a9-148a3daef6e6.jpg",
      title: "Dessert Masterpiece",
      description: "Sweet ending to perfection",
      chef: "Chef Olivia",
      difficulty: "Intermediate",
      category: "desserts",
      rating: 4.9,
      preparationTime: "60 min",
      featured: true
    },
    { 
      id: 10, 
      type: "image", 
      src: "/images/71c408a9-d60c-4378-9cb5-6c125e906128.jpg",
      title: "Grilled Perfection",
      description: "Fire-kissed flavors at their finest",
      chef: "Chef Roberto",
      difficulty: "Intermediate",
      category: "grilled",
      rating: 4.8,
      preparationTime: "25 min"
    },
    { 
      id: 11, 
      type: "image", 
      src: "/images/844a787c-2a01-400f-897a-7230df77ee2c.jpg",
      title: "Healthy Bowl Creation",
      description: "Nutritious and delicious combination",
      chef: "Chef Luna",
      difficulty: "Beginner",
      category: "healthy",
      rating: 4.6,
      preparationTime: "20 min"
    },
    { 
      id: 12, 
      type: "image", 
      src: "/images/8b63be61-6f04-45b8-94a1-11346d26a3b1.jpg",
      title: "Breakfast Specialty",
      description: "Start your day with excellence",
      chef: "Chef David",
      difficulty: "Beginner",
      category: "breakfast",
      rating: 4.7,
      preparationTime: "15 min"
    },
    { 
      id: 13, 
      type: "image", 
      src: "/images/b0c95ece-bd9b-49e1-9132-549191e6e7e4.jpg",
      title: "International Favorite",
      description: "Global flavors on your plate",
      chef: "Chef Sofia",
      difficulty: "Intermediate",
      category: "international",
      rating: 4.8,
      preparationTime: "40 min"
    },
    { 
      id: 14, 
      type: "image", 
      src: "/images/d5d4aedb-701e-4b7c-9dfd-5691c5c237ed.jpg",
      title: "Chef's Special",
      description: "Our signature creation",
      chef: "Chef Alexander",
      difficulty: "Advanced",
      category: "signature",
      rating: 5.0,
      preparationTime: "75 min",
      featured: true
    },
    { 
      id: 15, 
      type: "image", 
      src: "/images/d83a0deb-0754-41b9-b5ff-e51908b86839.jpg",
      title: "Seasonal Delight",
      description: "Fresh seasonal ingredients",
      chef: "Chef Victoria",
      difficulty: "Intermediate",
      category: "seasonal",
      rating: 4.7,
      preparationTime: "30 min"
    },
    { 
      id: 16, 
      type: "image", 
      src: "/images/f4c6b5c9-1bb4-4df1-ab3d-c71bde97cc59.jpg",
      title: "Gourmet Experience",
      description: "Fine dining at its best",
      chef: "Chef Gabriel",
      difficulty: "Advanced",
      category: "gourmet",
      rating: 4.9,
      preparationTime: "90 min",
      featured: true
    },
    { 
      id: 17, 
      type: "video", 
      src: "/images/WhatsApp Video 2025-07-07 at 5.14.47 PM.mp4",
      title: "Behind the Scenes",
      description: "Watch our chefs in action",
      chef: "Kitchen Team",
      difficulty: "Professional",
      category: "videos",
      rating: 4.8,
      preparationTime: "Live"
    },
    { 
      id: 18, 
      type: "video", 
      src: "/images/WhatsApp Video 2025-07-07 at 5.17.13 PM.mp4",
      title: "Cooking Process",
      description: "Step-by-step culinary magic",
      chef: "Kitchen Team",
      difficulty: "Professional",
      category: "videos",
      rating: 4.9,
      preparationTime: "Live"
    },
    { 
      id: 19, 
      type: "video", 
      src: "/images/WhatsApp Video 2025-07-07 at 5.17.20 PM.mp4",
      title: "Kitchen Chronicles",
      description: "Daily life in our kitchen",
      chef: "Kitchen Team",
      difficulty: "Professional",
      category: "videos",
      rating: 4.8,
      preparationTime: "Live"
    }
  ];

  // Intersection Observer for animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.dataset.id;
            setVisibleItems(prev => new Set([...prev, id]));
          }
        });
      },
      { threshold: 0.2 }
    );

    const items = galleryRef.current?.querySelectorAll('[data-id]');
    items?.forEach(item => observer.observe(item));

    return () => observer.disconnect();
  }, [galleryItems]);

  const handleImageLoad = (id) => {
    setLoadedImages(prev => new Set([...prev, id]));
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-amber-50">
      {/* Stunning Hero Section */}
      <div className="relative overflow-hidden bg-gradient-to-br from-gray-900 via-amber-900 to-orange-900">
        <div className="absolute inset-0 opacity-50">
          <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent"></div>
        </div>
        
        <div className="relative text-center py-12 sm:py-16 md:py-20 lg:py-24 px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            {/* Animated Title */}
            <div className="mb-6 sm:mb-8">
              <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl xl:text-9xl font-black text-transparent bg-clip-text bg-gradient-to-r from-amber-400 via-orange-500 to-amber-600 mb-4 leading-none tracking-tight">
                GALLERY
              </h1>
              <div className="flex items-center justify-center space-x-2 sm:space-x-4">
                <div className="h-0.5 sm:h-1 w-12 sm:w-16 lg:w-20 bg-gradient-to-r from-amber-500 to-orange-500 rounded-full"></div>
                <ChefHat className="w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8 text-amber-400" />
                <div className="h-0.5 sm:h-1 w-12 sm:w-16 lg:w-20 bg-gradient-to-r from-orange-500 to-amber-600 rounded-full"></div>
              </div>
            </div>

            <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-gray-300 mb-8 sm:mb-10 lg:mb-12 max-w-4xl mx-auto leading-relaxed font-light px-4">
              Explore our collection of <span className="text-amber-400 font-semibold">culinary masterpieces</span> and witness the artistry behind every dish
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <div className="inline-flex items-center bg-gradient-to-r from-amber-500 to-orange-500 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold text-base sm:text-lg hover:from-amber-600 hover:to-orange-600 transition-all duration-300 cursor-pointer group">
                <span>Explore Collection</span>
                <ArrowRight className="ml-2 w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform duration-300" />
              </div>
              
              <a 
                href="https://api.whatsapp.com/send/?phone=14242830606&text&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center bg-gradient-to-r from-green-500 to-green-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold text-base sm:text-lg hover:from-green-600 hover:to-green-700 transition-all duration-300 group shadow-lg hover:shadow-xl"
              >
                <ChefHat className="mr-2 w-4 h-4 sm:w-5 sm:h-5 group-hover:rotate-12 transition-transform duration-300" />
                <span>Book Chef Aaron</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Gallery Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16">
        <div 
          ref={galleryRef}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6 lg:gap-8"
        >
          {galleryItems.map((item, index) => (
            <div
              key={item.id}
              data-id={item.id}
              className={`group relative cursor-pointer transform transition-all duration-700 ${
                visibleItems.has(item.id.toString()) 
                  ? 'translate-y-0 opacity-100' 
                  : 'translate-y-12 opacity-0'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
              onMouseEnter={() => setHoveredItem(item.id)}
              onMouseLeave={() => setHoveredItem(null)}
              onClick={() => setSelectedImage(item)}
            >
              {/* Card Container */}
              <div className="relative bg-white rounded-xl sm:rounded-2xl overflow-hidden shadow-lg sm:shadow-xl hover:shadow-2xl transition-all duration-500 group-hover:-translate-y-2">
                {/* Media Container */}
                <div className="relative aspect-[4/3] overflow-hidden">
                  {item.type === "image" ? (
                    <>
                      <img
                        src={item.src}
                        alt=""
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                        loading="lazy"
                        onLoad={() => handleImageLoad(item.id)}
                      />
                      {!loadedImages.has(item.id) && (
                        <div className="absolute inset-0 bg-gray-200 animate-pulse flex items-center justify-center">
                          <div className="w-6 h-6 sm:w-8 sm:h-8 border-3 border-amber-500 border-t-transparent rounded-full animate-spin"></div>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="relative w-full h-full">
                      <video
                        src={item.src}
                        className="w-full h-full object-cover"
                        muted
                        preload="metadata"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent flex items-center justify-center">
                        <div className="bg-white/95 backdrop-blur-sm rounded-full p-3 sm:p-4 group-hover:scale-110 transition-transform duration-300 shadow-2xl">
                          <Play className="w-6 h-6 sm:w-8 sm:h-8 text-amber-600" fill="currentColor" />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Floating Book Chef Aaron Button */}
      <div className="fixed bottom-6 right-6 z-40">
        <a 
          href="https://api.whatsapp.com/send/?phone=14242830606&text=Hi%20Chef%20Aaron,%20I%20would%20like%20to%20book%20your%20services!&type=phone_number&app_absent=0"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center bg-gradient-to-r from-green-500 to-green-600 text-white px-6 py-3 rounded-full font-semibold text-sm hover:from-green-600 hover:to-green-700 transition-all duration-300 group shadow-2xl hover:shadow-3xl hover:scale-105"
        >
          <ChefHat className="mr-2 w-5 h-5 group-hover:rotate-12 transition-transform duration-300" />
          <span className="hidden sm:inline">Book Chef Aaron</span>
          <span className="sm:hidden">Book Chef</span>
        </a>
      </div>

      {/* Clean Modal */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-2 sm:p-4 backdrop-blur-sm">
          {/* Simple Close Button */}
          <div className="absolute top-4 right-4 sm:top-6 sm:right-6 z-10">
            <button
              onClick={() => setSelectedImage(null)}
              className="p-2 sm:p-3 bg-white/10 backdrop-blur-sm rounded-full hover:bg-white/20 transition-all duration-200"
            >
              <X className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
            </button>
          </div>
          
          {/* Media Content */}
          <div className="max-w-full max-h-full w-full flex items-center justify-center px-2 sm:px-4">
            {selectedImage.type === "image" ? (
              <img
                src={selectedImage.src}
                alt="Gallery image"
                className="max-w-full max-h-[85vh] sm:max-h-[90vh] object-contain rounded-lg sm:rounded-xl shadow-2xl"
              />
            ) : (
              <video
                src={selectedImage.src}
                controls
                autoPlay
                className="max-w-full max-h-[85vh] sm:max-h-[90vh] object-contain rounded-lg sm:rounded-xl shadow-2xl"
              />
            )}
          </div>
        </div>
      )}

      <style jsx>{`
        .animate-in {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
        
        .gallery-item:nth-child(4n) {
          height: 450px;
        }
        
        .gallery-item:nth-child(7n) {
          height: 300px;
        }
      `}</style>
    </div>
  );
};

export default Gallery;